export default __webpack_public_path__ + "static/media/vi_upload_other_documents.d766d2ae.svg";